import React from 'react';
import Spinner from '../../../common/Spinner/Spinner';
import { HighlightHashtagItem } from '../../../../api/highlightServices';
import './HighlightHashtagTooltip.css';

interface HighlightHashtagTooltipProps {
    hashtags: HighlightHashtagItem[];
    onSelect: (
      text: string,
      type: 'hashtag',
      tag_id?: number
    ) => void;
    loading?: boolean;
    position?: {
      top: number;
      left: number;
    };
    searchText?: string;
}

const HighlightHashtagTooltip: React.FC<HighlightHashtagTooltipProps> = ({
  hashtags,
  onSelect,
  loading = false,
  position,
  searchText
}) => {
  const handleRowClick = (
    e: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>, 
    hashtag: HighlightHashtagItem
  ) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (hashtag.highlight_text !== "Start typing...") {
      onSelect(hashtag.highlight_text, 'hashtag', undefined);
    }
  };

  const handleCreateNewHashtag = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (searchText) {
      onSelect(searchText, 'hashtag', undefined);
    }
  };

  const getPlaceholderText = () => {
    return 'Start typing a hashtag...';
  };

  return (
    <div 
      className="highlight-tooltip"
      style={{
        top: position ? `${position.top}px` : '0',
        left: position ? `${position.left}px` : '0',
        visibility: position ? 'visible' : 'hidden',
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      {loading ? (
        <div className="highlight-loading">
          <Spinner size={20} color="#666" />
        </div>
      ) : (
        <>
          {searchText && hashtags.length === 0 && (
            <div 
              className="highlight-row create-hashtag"
              role="button"
              tabIndex={0}
              onClick={handleCreateNewHashtag}
              style={{ 
                cursor: 'pointer',
                userSelect: 'none',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '8px',
                color: '#0095F6'
              }}
            >
              <div className="highlight-info">
                <span className="highlight-text">
                  Create #{searchText}
                </span>
              </div>
              <span className="highlight-count new-tag">
                New Tag
              </span>
            </div>
          )}
          
          {hashtags.length > 0 ? (
            hashtags.map((hashtag, index) => (
              <div 
                key={index}
                className="highlight-row"
                role="button"
                tabIndex={0}
                onClick={(e) => handleRowClick(e, hashtag)}
                onTouchStart={(e) => handleRowClick(e, hashtag)}
                style={{ 
                  cursor: hashtag.highlight_text === getPlaceholderText() ? 'default' : 'pointer',
                  color: hashtag.highlight_text === getPlaceholderText() ? '#999' : undefined,
                  userSelect: 'none',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '8px'
                }}
              >
                <div className="highlight-info">
                  <span className="highlight-text">
                    #{hashtag.highlight_text}
                  </span>
                </div>
                {hashtag.highlight_text !== getPlaceholderText() && (
                  <span className="highlight-count">
                    {hashtag.count} posts
                  </span>
                )}
              </div>
            ))
          ) : searchText ? null : (
            <div className="highlight-row">
              <div className="highlight-info">
                <span className="highlight-text" style={{ color: '#999' }}>
                  {getPlaceholderText()}
                </span>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default HighlightHashtagTooltip; 